import React from 'react';
import { Validation, ValidationProps } from 'ui';

import styles from './filter-validation-wrapper.scss';

export const FilterValidationWrapper: React.FC<{
  validationProp: ValidationProps;
  showValidation?: boolean;
  children?: React.ReactNode;
}> = ({
  validationProp, showValidation = true, children
}) => {
    const hasValidation = (validationProp?.messages?.length ?? 0) > 0;

    return hasValidation && showValidation
      ? <>
        <div className={styles.validationWrapper}>
          {children}
        </div>
        {hasValidation && <Validation {...validationProp} />}
      </>
      : <>{children}</>;
  };
